$(() => {
  const stickyBar = $('#article-sticky');

  // only run on pages with sticky bar
  if (stickyBar.length > 0) {
    const headers = $('header.header-nav');
    const header = Array.from(headers).find(
      elem => window.getComputedStyle(elem).display !== 'none'
    );
    const positionFromTop = stickyBar.position().top;
    const articlesContainer = $('.all-articles');
    const articlesContainerPadding = parseInt(
      articlesContainer.css('padding-top').replace('px', '')
    );

    const changeStickyBarPosition = () => {
      stickyBar.css({ 'margin-left': -stickyBar.position().left });
    };

    changeStickyBarPosition();

    $(window).resize(() => {
      changeStickyBarPosition();
    });

    $(window).scroll(() => {
      if ($(window).scrollTop() + header.scrollHeight >= positionFromTop) {
        stickyBar.addClass('fixed');
        stickyBar.css('top', header.scrollHeight);
        articlesContainer.css(
          'padding-top',
          stickyBar.height() + articlesContainerPadding
        );
      } else {
        stickyBar.removeClass('fixed');
        articlesContainer.css('padding-top', articlesContainerPadding);
      }

      changeStickyBarPosition();
    });
  }
});

$(() => {
  $('#article-search-form input').keyup(() => {
    $.get(
      $('#article-search-form').attr('index'),
      $('#article-search-form').serialize(),
      null,
      'script'
    );
    return false;
  });
});
